(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pet-portrait-builder"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('pet-portrait-builder')) return;

    var KEYS = ['bg', 'size', 'frame'];
    // Rækkefølgen valg låses i: farve > ramme > størrelse (rammen bestemmer, hvilke størrelser der findes)
    var LOCK = ['bg', 'frame', 'size'];
    // Væggen bag størrelsesvalget – tegnet i cm (300 × 187,5), så plakaten kan vises i rigtig størrelse
    var ROOM_SCENE = '<svg class="ppb-room__scene" viewBox="0 0 300 187.5" preserveAspectRatio="none" focusable="false"><defs><linearGradient id="ppbW" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#F2EBE3"/><stop offset="1" stop-color="#E8DED3"/></linearGradient><radialGradient id="ppbL" cx=".22" cy=".05" r=".9"><stop offset="0" stop-color="#fff" stop-opacity=".55"/><stop offset=".6" stop-color="#fff" stop-opacity="0"/></radialGradient><linearGradient id="ppbF" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#CDB79F"/><stop offset="1" stop-color="#BEA488"/></linearGradient></defs><rect width="300" height="170" fill="url(#ppbW)"/><rect width="300" height="170" fill="url(#ppbL)"/><rect y="165.5" width="300" height="4.5" fill="#F7F2EC"/><rect y="165.3" width="300" height=".4" fill="#DCD0C2"/><rect y="170" width="300" height="17.5" fill="url(#ppbF)"/><path d="M18 170 V187.5" stroke="#B49A7E" stroke-width=".35" opacity=".55"/><path d="M64 170 V187.5" stroke="#B49A7E" stroke-width=".35" opacity=".55"/><path d="M110 170 V187.5" stroke="#B49A7E" stroke-width=".35" opacity=".55"/><path d="M156 170 V187.5" stroke="#B49A7E" stroke-width=".35" opacity=".55"/><path d="M202 170 V187.5" stroke="#B49A7E" stroke-width=".35" opacity=".55"/><path d="M248 170 V187.5" stroke="#B49A7E" stroke-width=".35" opacity=".55"/><path d="M294 170 V187.5" stroke="#B49A7E" stroke-width=".35" opacity=".55"/><ellipse cx="150" cy="170.6" rx="78" ry="2.4" fill="#000" opacity=".10"/><rect x="86.5" y="158" width="3" height="12" rx=".8" fill="#8C6A4C"/><rect x="210.5" y="158" width="3" height="12" rx=".8" fill="#8C6A4C"/><rect x="80" y="116" width="140" height="44" rx="1.4" fill="#CBA481"/><rect x="79" y="114" width="142" height="3" rx="1" fill="#B98F69"/><path d="M126.7 119V157M173.3 119V157" stroke="#A97F5B" stroke-width=".55"/><rect x="80" y="156.5" width="140" height="3.5" fill="#000" opacity=".06"/><circle cx="122.7" cy="137" r="1" fill="#8C6A4C"/><circle cx="130.7" cy="137" r="1" fill="#8C6A4C"/><circle cx="169.3" cy="137" r="1" fill="#8C6A4C"/><circle cx="177.3" cy="137" r="1" fill="#8C6A4C"/><path d="M102 97 Q97.2 85.5 94.5 79" stroke="#9A8569" stroke-width=".5" fill="none"/><ellipse cx="94.5" cy="74" rx="3.2" ry="8.5" transform="rotate(-18 94.5 74)" fill="#E7D7C1"/><ellipse cx="94.5" cy="73" rx="1.76" ry="5.10" transform="rotate(-18 94.5 74)" fill="#F2E8DA"/><path d="M102 97 Q101.6 82.0 103.2 72" stroke="#9A8569" stroke-width=".5" fill="none"/><ellipse cx="103.2" cy="67" rx="3.4" ry="9.5" transform="rotate(2 103.2 67)" fill="#E7D7C1"/><ellipse cx="103.2" cy="66" rx="1.87" ry="5.70" transform="rotate(2 103.2 67)" fill="#F2E8DA"/><path d="M102 97 Q105.8 87.5 111.5 83" stroke="#9A8569" stroke-width=".5" fill="none"/><ellipse cx="111.5" cy="78" rx="3" ry="7.5" transform="rotate(22 111.5 78)" fill="#E7D7C1"/><ellipse cx="111.5" cy="77" rx="1.65" ry="4.50" transform="rotate(22 111.5 78)" fill="#F2E8DA"/><path d="M98.5 114 C95 108 95.5 101 99.8 97.2 L104.2 97.2 C108.5 101 109 108 105.5 114 Z" fill="#D7A68F"/><path d="M99.8 97.2 L104.2 97.2" stroke="#C18F78" stroke-width=".6"/><rect x="182" y="110" width="25" height="4" rx=".5" fill="#5B0A0D"/><rect x="184" y="106.4" width="21" height="3.6" rx=".5" fill="#DCCBB9"/><circle cx="195" cy="103.6" r="2.8" fill="#F5EFE8" stroke="#DCCFC0" stroke-width=".35"/><path d="M254 146 Q250.0 141.0 246 128" stroke="#5E7A50" stroke-width=".7" fill="none"/><path d="M254 146 Q258.0 139.0 262 124" stroke="#5E7A50" stroke-width=".7" fill="none"/><path d="M254 146 Q254.0 132.5 254 111" stroke="#5E7A50" stroke-width=".7" fill="none"/><path d="M254 146 Q247.0 133.0 240 112" stroke="#5E7A50" stroke-width=".7" fill="none"/><path d="M254 146 Q261.0 131.0 268 108" stroke="#5E7A50" stroke-width=".7" fill="none"/><path d="M254 146 Q253.0 125.0 252 96" stroke="#5E7A50" stroke-width=".7" fill="none"/><path d="M254 146 Q250.0 146.5 246 139" stroke="#5E7A50" stroke-width=".7" fill="none"/><path d="M254 146 Q258.0 146.5 262 139" stroke="#5E7A50" stroke-width=".7" fill="none"/><ellipse cx="246" cy="128" rx="5" ry="13" transform="rotate(-25 246 128)" fill="#6F8B5E"/><ellipse cx="262" cy="124" rx="5" ry="14" transform="rotate(22 262 124)" fill="#5E7C50"/><ellipse cx="254" cy="111" rx="5.5" ry="15" transform="rotate(-4 254 111)" fill="#7A9568"/><ellipse cx="240" cy="112" rx="4.5" ry="12" transform="rotate(-40 240 112)" fill="#5E7C50"/><ellipse cx="268" cy="108" rx="4.5" ry="12" transform="rotate(35 268 108)" fill="#6F8B5E"/><ellipse cx="252" cy="96" rx="4.2" ry="11" transform="rotate(8 252 96)" fill="#5E7C50"/><ellipse cx="246" cy="139" rx="4" ry="9" transform="rotate(-62 246 139)" fill="#7A9568"/><ellipse cx="262" cy="139" rx="4" ry="9" transform="rotate(60 262 139)" fill="#6F8B5E"/><path d="M242 146 H266 L263 169.5 H245 Z" fill="#EEE7DE" stroke="#DCD0C2" stroke-width=".4"/><rect x="241" y="145" width="26" height="2.4" rx=".8" fill="#E4DBD0"/></svg>';
    var PAW_SVG = '<svg class="ppb-room__paw" viewBox="0 0 64 64" focusable="false"><ellipse cx="17" cy="27" rx="6" ry="8" transform="rotate(-20 17 27)"/><ellipse cx="27" cy="17" rx="6" ry="8.5" transform="rotate(-6 27 17)"/><ellipse cx="39" cy="17" rx="6" ry="8.5" transform="rotate(6 39 17)"/><ellipse cx="49" cy="27" rx="6" ry="8" transform="rotate(20 49 27)"/><path d="M33 30c-7 0-15 9-15 16 0 5 4 8 8 7 3-1 5-2 7-2s4 1 7 2c4 1 8-2 8-7 0-7-8-16-15-16z"/></svg>';

    class PetPortraitBuilder extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        var dataEl = this.querySelector('[data-ppb-data]');
        if (!dataEl) return;
        try {
          this.d = JSON.parse(dataEl.textContent);
        } catch (e) {
          console.error('[Kæledyrsportræt] Kunne ikke læse produktdata', e);
          return;
        }
        this._ready = true;
        this.t = this.d.text || {};
        this.$ = (sel) => this.querySelector(sel);
        this.form = this.$('[data-ppb-form]');
        this.variantInput = this.$('[data-ppb-variant]');
        this.fileInput = this.$('[data-ppb-file]');
        this.nameInput = this.$('[data-ppb-name]');
        this.drop = this.$('[data-ppb-drop]');
        this.errorEl = this.$('[data-ppb-error]');
        this.nextBtn = this.$('[data-ppb-next]');
        this.backBtn = this.$('[data-ppb-back]');
        this.map = this.parseMap(this.d.swatchMap);
        this.badge = this.parseBadge(this.d.badge);
        this.resolveOptions();

        var variants = this.d.variants || [];
        var start =
          variants.find((v) => v.id === this.d.selectedVariant && v.available) ||
          variants.find((v) => v.available) ||
          variants[0];
        this.sel = start ? start.options.slice() : [];
        // Kommer kunden fra et link (fx et portrætkort), huskes linkets variant, så det rigtige billede vises
        this.linkSel = /[?&]variant=/.test(location.search) && start ? start.options.slice() : null;
        // Prisen starter altid uden ramme – også når linket peger på en variant med ramme
        if (this.idx.frame > -1 && this.sel.length && !this.frameInfo(this.sel[this.idx.frame]).none) {
          var noFrame = (this.d.options[this.idx.frame].values || []).find((v) => this.frameInfo(v.name).none);
          var plain = noFrame && this.resolve('frame', noFrame.name);
          if (plain) this.sel = plain.options.slice();
        }

        this.steps = [];
        if (this.idx.bg > -1) this.steps.push(1);
        if (this.idx.size > -1 || this.idx.frame > -1) this.steps.push(2);
        this.steps.push(3);

        this.decorateTips();
        this.bind();
        this.setupLater();
        this.render();
        this.updateEta();
        this.goTo(this.steps[0], false);
        // Kommer kunden fra et link med en bestemt variant (fx et produktkort), vis det rigtige billede med det samme
        if (/[?&]variant=/.test(location.search)) this.syncGalleryOnLoad();
        this.setupSticky();
      }

      disconnectedCallback() {
        if (this.stickyBar) this.stickyBar.classList.remove('is-on');
      }

      /* ---------- send billedet senere ---------- */

      setupLater() {
        this.laterInput = this.$('[data-ppb-later]');
        this.laterProp = this.$('[data-ppb-later-prop]');
        if (!this.laterInput) return;
        this.laterInput.addEventListener('change', () => {
          var on = this.laterInput.checked;
          if (on && this.fileInput.files && this.fileInput.files.length) {
            this.fileInput.value = '';
            this.setPhoto(null);
          }
          this.setLater(on);
        });
      }

      setLater(on) {
        this.later = !!on;
        if (this.laterInput) this.laterInput.checked = this.later;
        if (this.laterProp) this.laterProp.disabled = !this.later;
        this.classList.toggle('is-later', this.later);
        this.drop.classList.remove('is-invalid');
        this.clearError();
        this.updatePreview();
      }

      /* ---------- fast knap i bunden (mobil) ---------- */

      setupSticky() {
        var bar = this.$('[data-ppb-sticky]');
        var actions = this.$('.ppb-actions');
        if (!bar || !actions || !('IntersectionObserver' in window)) return;
        // Flyttes ud i <body>, så position: fixed virker uanset temaets layout
        var cs = getComputedStyle(this);
        ['--ppb-accent', '--ppb-accent-text', '--ppb-ink', '--ppb-muted'].forEach((v) => {
          var val = cs.getPropertyValue(v);
          if (val) bar.style.setProperty(v, val.trim());
        });
        bar.style.fontFamily = cs.fontFamily;
        document.body.appendChild(bar);
        this.stickyBar = bar;
        this.stickyMq = window.matchMedia('(max-width: 749px)');
        this._actionsVisible = true;
        new IntersectionObserver((entries) => {
          this._actionsVisible = entries[entries.length - 1].isIntersecting;
          this.syncSticky();
        }).observe(actions);
        var queued = false;
        window.addEventListener('scroll', () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => { queued = false; this.syncSticky(); });
        }, { passive: true });
        var sub = this.$('.ppb-subtotal');
        if (sub && 'MutationObserver' in window) {
          new MutationObserver(() => this.syncSticky()).observe(sub, { subtree: true, childList: true, characterData: true });
        }
        bar.querySelector('[data-ppb-sticky-btn]').addEventListener('click', () => {
          if (!this.builderReached()) {
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          this.next();
          if (!this.errorEl.hidden) this.errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        this.syncSticky();
      }

      builderReached() {
        return this.getBoundingClientRect().top <= window.innerHeight * 0.6;
      }

      syncSticky() {
        var bar = this.stickyBar;
        if (!bar) return;
        var on = this.stickyMq.matches && !this._actionsVisible && !this.loading && this.isConnected;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', String(!on));
        var label = this.builderReached() ? this.$('[data-ppb-next-label]').textContent : 'Lav dit portræt';
        bar.querySelector('[data-ppb-sticky-label]').textContent = label;
        bar.querySelector('[data-ppb-sticky-price]').textContent = this.$('[data-ppb-price]').textContent;
        var c = this.$('[data-ppb-compare]');
        var sc = bar.querySelector('[data-ppb-sticky-compare]');
        sc.hidden = c.hidden;
        sc.textContent = c.hidden ? '' : c.textContent;
      }

      syncGalleryOnLoad() {
        var run = () => {
          this._lastGalleryFile = null;
          this.syncGallery({ initial: true, sel: this.linkSel });
        };
        var ready =
          window.customElements && customElements.whenDefined
            ? Promise.race([customElements.whenDefined('slideshow-component'), new Promise((r) => setTimeout(r, 2000))])
            : Promise.resolve();
        ready.then(() => setTimeout(() => requestAnimationFrame(run), 300));
      }

      decorateTips() {
        var re;
        try {
          re = new RegExp('^((?:\\p{Extended_Pictographic}|\\p{Emoji_Modifier}|\\u200d|\\ufe0f)+)\\s*', 'u');
        } catch (e) {
          return;
        }
        this.querySelectorAll('.ppb-tips__list li').forEach((li) => {
          var textEl = li.querySelector('.ppb-tips__text');
          if (!textEl || li.querySelector('.ppb-tips__emoji')) return;
          var t = textEl.textContent.trim();
          var m = re.exec(t);
          var emoji = m ? m[1] : '🐾';
          if (m) textEl.textContent = t.slice(m[0].length);
          li.insertBefore(this.el('span', 'ppb-tips__emoji', emoji), textEl);
        });
      }

      disconnectedCallback() {
        if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
      }

      /* ---------- data ---------- */

      // "Limited Edition" = mærkat på alle baggrunde med tillæg.
      // "Limited Edition: Salviegrøn, Skagen, Klit" = mærkat på netop de farver.
      parseBadge(raw) {
        var text = String(raw || '').trim();
        var i = text.indexOf(':');
        if (i < 0) return { label: text, names: null };
        var norm = (x) => String(x || '').toLowerCase().normalize('NFC').replace(/\s+/g, ' ').trim();
        return {
          label: text.slice(0, i).trim(),
          names: text.slice(i + 1).split(',').map(norm).filter(Boolean),
        };
      }

      hasBadge(name, diff) {
        var b = this.badge || { label: '' };
        if (!b.label) return false;
        if (!b.names) return diff > 0;
        return b.names.indexOf(String(name || '').toLowerCase().normalize('NFC').replace(/\s+/g, ' ').trim()) > -1;
      }

      parseMap(raw) {
        var map = {};
        String(raw || '')
          .split(/\r?\n/)
          .forEach((line) => {
            var i = line.indexOf(':');
            if (i < 1) return;
            var key = line.slice(0, i).trim().toLowerCase();
            var val = line.slice(i + 1).trim();
            if (key && val) map[key] = val;
          });
        return map;
      }

      resolveOptions() {
        var opts = this.d.options || [];
        var names = opts.map((o) => String(o.name || '').trim().toLowerCase());
        var idx = { bg: -1, size: -1, frame: -1 };
        var isDefault =
          opts.length === 1 && opts[0].values.length === 1 && /^default title$/i.test(opts[0].values[0].name);
        if (!isDefault) {
          var used = {};
          KEYS.forEach((k) => {
            var want = String((this.d.optionNames || {})[k] || '').trim().toLowerCase();
            var i = want ? names.indexOf(want) : -1;
            if (i > -1 && !used[i]) {
              idx[k] = i;
              used[i] = true;
            }
          });
          var next = 0;
          KEYS.forEach((k) => {
            if (idx[k] > -1) return;
            while (used[next]) next++;
            if (next < names.length) {
              idx[k] = next;
              used[next] = true;
            }
          });
        }
        this.idx = idx;
      }

      variantFor(sel) {
        return (this.d.variants || []).find((v) => v.options.every((o, i) => o === sel[i]));
      }

      withValue(key, value) {
        var s = this.sel.slice();
        s[this.idx[key]] = value;
        return this.variantFor(s);
      }

      valueObj(key) {
        var i = this.idx[key];
        if (i < 0) return null;
        return this.d.options[i].values.find((v) => v.name === this.sel[i]) || null;
      }

      /* ---------- formatting helpers ---------- */

      fmt(cents) {
        var amount = cents / 100;
        try {
          return new Intl.NumberFormat(this.d.locale || undefined, {
            style: 'currency',
            currency: this.d.currency || 'DKK',
            minimumFractionDigits: cents % 100 ? 2 : 0,
            maximumFractionDigits: 2,
          }).format(amount);
        } catch (e) {
          return amount.toFixed(2) + ' ' + (this.d.currency || '');
        }
      }

      parseDims(name) {
        var m = /(\d+(?:[.,]\d+)?)\s*(?:["″']{1,2}|cm|in)?\s*[x×*]\s*(\d+(?:[.,]\d+)?)/i.exec(String(name || ''));
        if (!m) return null;
        var a = parseFloat(m[1].replace(',', '.'));
        var b = parseFloat(m[2].replace(',', '.'));
        return a > 0 && b > 0 ? { w: Math.min(a, b), h: Math.max(a, b) } : null;
      }

      // Tegner en væg med plakaten i den valgte farve – plakaten vokser med størrelsen
      sizeArt(values, n) {
        var dims = values.map((v) => this.parseDims(v.name));
        var maxH = Math.max.apply(null, dims.map((d) => (d ? d.h : 0)));
        var d = dims[n];
        var ratio = d && maxH ? d.h / maxH : (n + 1) / values.length;
        var aspect = d ? d.w / d.h : 0.75;
        var ph = Math.max(44, Math.round(196 * ratio));
        var pw = Math.round(ph * aspect);
        var px = Math.round(140 - pw / 2);
        var py = Math.max(18, Math.round(120 - ph / 2));
        var bg = this.bgStyle(this.valueObj('bg'));
        var fill = /^(#[0-9a-f]{3,8}|rgba?\([^)]*\))$/i.test(String(bg).trim()) ? String(bg).trim() : '#fafaf8';
        var f = this.frameInfo(this.idx.frame > -1 ? this.sel[this.idx.frame] : null);
        var frame = f.none ? '' : '<rect x="' + (px - 3) + '" y="' + (py - 3) + '" width="' + (pw + 6) + '" height="' + (ph + 6) + '" fill="none" stroke="' + String(f.color).replace(/[^#\w(),. %-]/g, '') + '" stroke-width="6"/>';
        var leaves = [[372, 40, -35], [352, 70, 30], [384, 92, -20], [346, 110, 42], [380, 132, -8], [356, 150, 35], [388, 172, 5]]
          .map((l) => '<ellipse cx="' + l[0] + '" cy="' + l[1] + '" rx="30" ry="8" transform="rotate(' + l[2] + ' ' + l[0] + ' ' + l[1] + ')" fill="#4d7a44"/>').join('');
        return '<svg class="ppb-sizeart" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false">' +
          '<rect width="400" height="300" fill="#dcdbd8"/>' +
          '<path d="M372 300 C370 230 368 160 372 20" stroke="#3f6737" stroke-width="3" fill="none"/>' + leaves +
          '<rect x="' + (px + 3) + '" y="' + (py + 4) + '" width="' + pw + '" height="' + ph + '" fill="rgba(0,0,0,.10)"/>' +
          '<rect x="' + px + '" y="' + py + '" width="' + pw + '" height="' + ph + '" fill="' + fill + '"/>' + frame +
          '<rect x="218" y="214" width="98" height="72" rx="30" fill="#a9a9a7"/>' +
          '<rect x="204" y="254" width="126" height="48" rx="16" fill="#bdbcb9"/>' +
          '<rect x="242" y="238" width="50" height="28" rx="9" fill="#e9e3d8"/>' +
          '</svg>';
      }

      bgStyle(val) {
        if (!val) return '#f5f4f0';
        var m = this.map[String(val.name).trim().toLowerCase()];
        if (m) return /^(https?:)?\/\//i.test(m) ? 'url("' + m.replace(/"/g, '%22') + '") center / cover no-repeat' : m;
        if (val.image) return 'url("' + String(val.image).replace(/"/g, '%22') + '") center / cover no-repeat';
        if (val.color) return val.color;
        if (window.CSS && CSS.supports && CSS.supports('color', val.name)) return val.name;
        return '#eeebe6';
      }

      frameInfo(name) {
        if (!name) return { none: true };
        var key = String(name).trim().toLowerCase();
        var m = this.map[key];
        if (m) return /^(none|ingen|uden)$/i.test(m) ? { none: true } : { none: false, color: m };
        if (/(uden|ingen|without|no frame|unframed|none|^nej$|^no$)/.test(key)) return { none: true };
        if (/(hvid|white)/.test(key)) return { none: false, color: '#f3f3f1' };
        if (/((^|\s)eg|oak|træ|trae|wood|natur)/.test(key)) return { none: false, color: '#c49a6c' };
        return { none: false, color: '#1e1e1e' };
      }

      isDark(css) {
        var s = String(css || '').trim();
        var r, g, b, m;
        if ((m = /^#([0-9a-f]{3})$/i.exec(s))) {
          r = parseInt(m[1][0] + m[1][0], 16); g = parseInt(m[1][1] + m[1][1], 16); b = parseInt(m[1][2] + m[1][2], 16);
        } else if ((m = /^#([0-9a-f]{6})/i.exec(s))) {
          r = parseInt(m[1].slice(0, 2), 16); g = parseInt(m[1].slice(2, 4), 16); b = parseInt(m[1].slice(4, 6), 16);
        } else if ((m = /^rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/i.exec(s))) {
          r = +m[1]; g = +m[2]; b = +m[3];
        } else {
          return false;
        }
        return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255 < 0.45;
      }

      /* ---------- events ---------- */

      bind() {
        this.nextBtn.addEventListener('click', () => this.next());
        this.backBtn.addEventListener('click', () => this.back());
        this.addonInputs = Array.prototype.slice.call(this.querySelectorAll('[data-ppb-addon]'));
        this.addonInputs.forEach((cb) => {
          var priceEl = cb.closest('.ppb-extra').querySelector('[data-ppb-addon-price]');
          if (priceEl) priceEl.textContent = '+' + this.fmt(Number(cb.dataset.price) || 0);
          cb.addEventListener('change', () => this.updatePrice());
        });
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.next();
        });

        // Kun vis fokus-ring ved tastatur, ikke ved klik
        this.addEventListener('pointerdown', () => { this._pointer = true; });
        this.addEventListener('keydown', () => { this._pointer = false; });

        this.fileInput.addEventListener('change', () => this.onFile(this.fileInput.files[0]));
        ['dragenter', 'dragover'].forEach((type) =>
          this.drop.addEventListener(type, (e) => {
            e.preventDefault();
            this.drop.classList.add('is-dragover');
          })
        );
        ['dragleave', 'drop'].forEach((type) =>
          this.drop.addEventListener(type, () => this.drop.classList.remove('is-dragover'))
        );
        this.drop.addEventListener('drop', (e) => {
          e.preventDefault();
          var files = e.dataTransfer && e.dataTransfer.files;
          if (!files || !files.length) return;
          try {
            this.fileInput.files = files;
          } catch (err) {}
          this.onFile(files[0]);
        });

        this.nameInput.addEventListener('input', () => {
          this.nameInput.classList.remove('is-invalid');
          this.updateCount();
          this.updatePreview();
          this.clearError();
        });
      }

      // Finder den variant et klik ville ende på. Valg i tidligere trin ligger fast
      // (baggrund > størrelse > ramme); senere valg justeres automatisk, hvis kombinationen ikke findes.
      resolve(key, value) {
        var i = this.idx[key];
        var exact = this.withValue(key, value);
        if (exact && exact.available) return exact;
        var locked = LOCK.slice(0, LOCK.indexOf(key))
          .map((k) => this.idx[k])
          .filter((j) => j > -1);
        var si = this.idx.size;
        var cur = si > -1 ? this.sizeCm(this.sel[si]) : null;
        // Findes størrelsen ikke med det nye valg, vælges den størrelse, der ligger tættest på
        var gap = (x) => {
          var c = si > -1 ? this.sizeCm(x.options[si]) : null;
          return c && cur ? Math.abs(c.w * c.h - cur.w * cur.h) : 0;
        };
        var score = (x) => x.options.reduce((n, o, j) => n + (o === this.sel[j] ? 1 : 0), 0);
        var candidates = (this.d.variants || []).filter(
          (x) => x.available && x.options[i] === value && locked.every((j) => x.options[j] === this.sel[j])
        );
        candidates.sort((a, b) => score(b) - score(a) || gap(a) - gap(b) || a.price - b.price);
        return candidates[0] || null;
      }

      /* "Billedet er kun et eksempel" – vises, når kunden vælger en farve */
      noteAnyAnimal(value) {
        var note = this.$('[data-ppb-anyanimal]');
        if (!note) return;
        var name = this.$('[data-ppb-anyanimal-color]');
        if (name) name.textContent = value;
        note.hidden = false;
      }

      choose(key, value) {
        var v = this.resolve(key, value);
        if (!v) return;
        this.sel = v.options.slice();
        if (key === 'frame' && !this.frameInfo(value).none) this.lastFramed = value;
        this.render();
        var wrap = this.$('[data-ppb-group="' + key + '"]');
        var btn = wrap && Array.prototype.find.call(wrap.children, (b) => b.dataset.value === value);
        if (!btn && key === 'frame') {
          var subWrap = this.$('[data-ppb-group="framecolor"]');
          btn = subWrap && Array.prototype.find.call(subWrap.children, (b) => b.dataset.value === value);
        }
        if (btn && !this._pointer) btn.focus({ preventScroll: true });
        this.clearError();
        if (key === 'bg') this.noteAnyAnimal(value);
        this.syncGallery();
        this.dispatchEvent(
          new CustomEvent('pet-portrait:change', { bubbles: true, detail: { variant: this.variantFor(this.sel) } })
        );
      }

      /* ---------- produktbilleder følger valget ----------
         1) Har varianten sit eget billede i Shopify, vises det.
         2) Ellers vises det billede, hvis alt-tekst indeholder den valgte farve
            (og gerne også ramme/størrelse), fx "Koksgrå" eller "Koksgrå Sort Ramme". */
      syncGallery(opts) {
        var initial = !!(opts && opts.initial);
        var media = this.d.media || [];
        if (!media.length) return;
        var norm = (x) => String(x || '').toLowerCase().normalize('NFC').replace(/\s+/g, ' ').trim();
        var sel = (opts && opts.sel) || this.sel;
        var v = this.variantFor(sel);
        var pick = null;
        if (v && v.media) pick = media.find((m) => m.id === v.media) || null;
        if (!pick) {
          var val = (k) => (this.idx[k] > -1 ? norm(sel[this.idx[k]]) : '');
          var bg = val('bg'), fr = val('frame'), sz = val('size');
          var best = null, bestScore = 0;
          media.forEach((m) => {
            var alt = norm(m.alt);
            if (!alt) return;
            var score = 0;
            if (bg && alt.indexOf(bg) > -1) score += 4;
            else if (bg) return;
            if (fr && alt.indexOf(fr) > -1) score += 2;
            if (sz && alt.indexOf(sz) > -1) score += 1;
            if (score > bestScore) { best = m; bestScore = score; }
          });
          pick = best;
        }
        if (!pick || !pick.file || pick.file === this._lastGalleryFile) return;
        this._lastGalleryFile = pick.file;

        var root = this.closest('.shopify-section') || document;
        var gallery = root.querySelector('media-gallery') || document.querySelector('media-gallery');
        if (!gallery) return;
        var file = norm(pick.file);
        var hit = (el) => {
          var img = el.querySelector('img');
          if (!img) return false;
          var src = norm(decodeURIComponent((img.getAttribute('src') || '') + ' ' + (img.getAttribute('srcset') || '')));
          return src.indexOf(file) > -1;
        };
        var slides = Array.prototype.slice.call(gallery.querySelectorAll('slideshow-slide'));
        var index = slides.findIndex(hit);
        var slideshow = gallery.slideshow || gallery.querySelector('slideshow-component');
        if (index > -1 && slideshow && typeof slideshow.select === 'function' && slideshow.offsetParent !== null) {
          try { slideshow.select(index, undefined, { animate: !initial }); } catch (e) {}
          return;
        }
        var items = Array.prototype.slice.call(gallery.querySelectorAll('.media-gallery__grid > li'));
        var item = items.find(hit);
        if (item && item.offsetParent !== null && !initial) {
          var r = item.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      /* ---------- rendering ---------- */

      render() {
        KEYS.forEach((k) => this.renderGroup(k));
        var obs = this.$('[data-ppb-obs]');
        if (obs) obs.hidden = this.idx.frame < 0 || this.frameInfo(this.sel[this.idx.frame]).none;
        this.updatePreview();
        this.updatePrice();
      }

      el(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        return n;
      }

      renderGroup(key) {
        var i = this.idx[key];
        var wrap = this.$('[data-ppb-group="' + key + '"]');
        var section = this.$('[data-ppb-section="' + key + '"]');
        var current = this.$('[data-ppb-current="' + key + '"]');
        if (!wrap) return;
        if (i < 0) {
          if (section) section.hidden = true;
          return;
        }
        var values = this.d.options[i].values;
        // Kun én ramme-mulighed (fx "Uden Ramme") – så er der intet at vælge, og feltet skjules
        if (key === 'frame' && values.length < 2) {
          if (section) section.hidden = true;
          return;
        }
        if (section) section.hidden = false;
        var prices = values.map((val) => {
          var v = this.resolve(key, val.name);
          return v ? v.price : null;
        });
        // Størrelser, der ikke findes med den valgte ramme (fx 50×70 med ramme), vises slet ikke
        if (key === 'size' && this.idx.frame > -1) {
          var fi = this.idx.frame;
          var fv = this.sel[fi];
          var keep = values.map((val) => (this.d.variants || []).some((x) => x.options[i] === val.name && x.options[fi] === fv));
          if (keep.some(Boolean)) {
            values = values.filter((v, n) => keep[n]);
            prices = prices.filter((p, n) => keep[n]);
          }
        }
        // Størrelserne vises fra mindst til størst, uanset rækkefølgen i Shopify
        if (key === 'size') {
          var area = (v) => {
            var c = this.sizeCm(v.name);
            return c ? c.w * c.h : Infinity;
          };
          var order = values.map((v, n) => n).sort((x, y) => area(values[x]) - area(values[y]) || x - y);
          values = order.map((n) => values[n]);
          prices = order.map((n) => prices[n]);
        }
        var valid = prices.filter((p) => p !== null);
        var base = valid.length ? Math.min.apply(null, valid) : 0;

        if (key === 'frame') {
          var sub = this.$('[data-ppb-subframe]');
          var subWrap = this.$('[data-ppb-group="framecolor"]');
          var noneIdx = [];
          var framedIdx = [];
          values.forEach((v, n) => (this.frameInfo(v.name).none ? noneIdx : framedIdx).push(n));
          if (noneIdx.length && framedIdx.length > 1 && sub && subWrap) {
            this.renderFrameSplit(values, prices, noneIdx, framedIdx, wrap, sub, subWrap);
            if (current) current.textContent = this.sel[i] || '';
            return;
          }
          if (sub) sub.hidden = true;
          wrap.className = 'ppb-seg';
          wrap.textContent = '';
          values.forEach((val, n) => {
            var price = prices[n];
            var meta = price === null ? this.t.unavailable : price > base ? '+' + this.fmt(price - base) : '';
            wrap.appendChild(this.segBtn(val.name, val.name, meta, this.sel[i] === val.name, price === null, () => this.choose('frame', val.name)));
          });
          if (current) current.textContent = this.sel[i] || '';
          return;
        }

        var tiles = key === 'size' && this.d.sizeStyle !== 'buttons';
        // Ingen egne størrelsesbilleder → én væg med plakaten i rigtig størrelse + fire kort
        if (tiles && !(this.d.sizeImages || []).some(Boolean)) {
          this.renderSizeRoom(values, prices, base, wrap);
          if (current) current.textContent = this.sel[i] || '';
          return;
        }
        if (key === 'size') {
          wrap.classList.toggle('ppb-grid--swatches', tiles);
          wrap.classList.toggle('ppb-grid--options', !tiles);
        }
        wrap.textContent = '';
        wrap.dataset.count = String(values.length);
        values.forEach((val, n) => {
          var price = prices[n];
          var diff = price !== null ? price - base : 0;
          var diffText = price === null ? this.t.unavailable : diff > 0 ? '+' + this.fmt(diff) : '';
          var cls = key === 'bg' ? 'ppb-choice--bg ppb-choice--tile' : tiles ? 'ppb-choice--sizetile ppb-choice--tile' : 'ppb-choice--' + key;
          var btn = this.el('button', 'ppb-choice ' + cls);
          btn.type = 'button';
          btn.dataset.value = val.name;
          btn.setAttribute('role', 'radio');
          btn.setAttribute('aria-checked', String(this.sel[i] === val.name));
          btn.disabled = price === null;

          if (key === 'bg' || tiles) {
            var sw = this.el('span', 'ppb-swatch' + (tiles ? ' ppb-swatch--size' : ''));
            if (key === 'bg') {
              sw.style.background = this.bgStyle(val);
            } else {
              var img = (this.d.sizeImages || [])[n];
              if (img) sw.style.background = 'url("' + String(img).replace(/"/g, '%22') + '") center / cover no-repeat';
              else sw.innerHTML = this.sizeArt(values, n);
            }
            if (price !== null && diff > 0) sw.appendChild(this.el('span', 'ppb-badge', diffText));
            btn.appendChild(sw);
            btn.appendChild(this.el('span', 'ppb-choice__name', val.name));
            if (key === 'bg' && price !== null && this.hasBadge(val.name, diff)) btn.appendChild(this.el('span', 'ppb-pill', this.badge.label));
            if (price === null) btn.appendChild(this.el('span', 'ppb-choice__meta', diffText));
            btn.setAttribute('aria-label', val.name + (diffText ? ', ' + diffText : ''));
          } else {
            var txt = this.el('span', 'ppb-choice__text');
            txt.appendChild(this.el('span', 'ppb-choice__name', val.name));
            if (diffText) txt.appendChild(this.el('span', 'ppb-choice__meta', diffText));
            btn.appendChild(txt);
          }
          btn.addEventListener('click', () => this.choose(key, val.name));
          wrap.appendChild(btn);
        });
        if (current) current.textContent = this.sel[i] || '';
      }

      // "Stor · 40×50 cm" → { title: "Stor", dims: "40×50 cm" }
      splitSize(name) {
        var str = String(name || '').trim();
        var m = /^(.*?)\s+[·•|–—-]\s+(.+)$/.exec(str);
        if (m && /\d/.test(m[2])) return { title: m[1], dims: m[2] };
        return { title: str, dims: '' };
      }

      // Plakatens mål i cm (tommer regnes om)
      sizeCm(name) {
        var d = this.parseDims(name);
        if (!d) return null;
        var inch = /["″]|\bin\b|inch/i.test(String(name)) && !/cm/i.test(String(name));
        var k = inch ? 2.54 : 1;
        return { w: d.w * k, h: d.h * k };
      }

      // Beløb for fri fragt, læst fra teksten "Fri fragt over 399 kr."
      freeFrom() {
        var m = /(\d[\d.\s]*)/.exec(String(this.d.shipNote || ''));
        if (!m) return null;
        var n = parseFloat(m[1].replace(/[.\s]/g, ''));
        return n > 0 ? Math.round(n * 100) : null;
      }

      renderSizeRoom(values, prices, base, wrap) {
        var i = this.idx.size;
        if (!this.room) {
          this.room = this.el('div', 'ppb-room');
          this.room.setAttribute('aria-hidden', 'true');
          this.room.innerHTML = ROOM_SCENE + '<div class="ppb-room__poster" data-ppb-room-poster>' + PAW_SVG + '</div>';
          wrap.parentNode.insertBefore(this.room, wrap);
          var note = this.el('p', 'ppb-room__note', this.t.roomNote || '');
          wrap.parentNode.insertBefore(note, wrap);
        }
        wrap.className = 'ppb-sizes';
        wrap.textContent = '';
        wrap.dataset.count = String(values.length);
        var dims = values.map((v) => this.sizeCm(v.name));
        var maxH = Math.max.apply(null, dims.map((d) => (d ? d.h : 0)).concat([1]));
        var free = this.freeFrom();
        // Står der fri fragt på alle kort, siger mærket ingenting – så vises det kun, når nogle størrelser er under grænsen
        if (free && prices.every((p) => p === null || p >= free)) free = null;
        var fill = this.bgStyle(this.valueObj('bg'));
        var fr = this.frameInfo(this.idx.frame > -1 ? this.sel[this.idx.frame] : null);
        values.forEach((val, n) => {
          var price = prices[n];
          var diff = price !== null ? price - base : 0;
          var parts = this.splitSize(val.name);
          var btn = this.el('button', 'ppb-choice ppb-sizecard' + (fr.none ? '' : ' is-framed'));
          if (!fr.none) btn.style.setProperty('--ppb-frame', fr.color);
          btn.type = 'button';
          btn.dataset.value = val.name;
          btn.setAttribute('role', 'radio');
          btn.setAttribute('aria-checked', String(this.sel[i] === val.name));
          btn.disabled = price === null;
          if (free && price !== null && price >= free) btn.appendChild(this.el('span', 'ppb-sizecard__flag', this.t.freeShip || 'Fri fragt'));
          var icon = this.el('span', 'ppb-sizecard__icon');
          var shape = this.el('span', 'ppb-sizecard__shape');
          var d = dims[n];
          shape.style.height = (d ? Math.max(34, Math.round((100 * d.h) / maxH)) : 50 + n * 12) + '%';
          shape.style.aspectRatio = d ? d.w.toFixed(1) + ' / ' + d.h.toFixed(1) : '3 / 4';
          shape.style.background = fill;
          icon.appendChild(shape);
          btn.appendChild(icon);
          if (parts.dims) {
            btn.appendChild(this.el('span', 'ppb-sizecard__name', parts.title));
            btn.appendChild(this.el('span', 'ppb-sizecard__dims', parts.dims));
          } else {
            // Kun mål (fx "30×40 cm") → stort "30 × 40" med "cm" nedenunder
            var unit = /\s*(cm|mm|in|″|")\s*$/i.exec(parts.title);
            btn.appendChild(this.el('span', 'ppb-sizecard__name', parts.title.replace(/\s*(cm|mm|in|″|")\s*$/i, '').replace(/\s*[×x*]\s*/i, ' × ')));
            if (unit) btn.appendChild(this.el('span', 'ppb-sizecard__dims', unit[1]));
          }
          var meta = price === null ? this.t.unavailable : diff > 0 ? '+' + this.fmt(diff) : '';
          btn.appendChild(this.el('span', 'ppb-sizecard__price', meta || '\u00a0'));
          btn.setAttribute('aria-label', val.name + (meta ? ', ' + meta : ''));
          btn.addEventListener('click', () => this.choose('size', val.name));
          wrap.appendChild(btn);
        });
        this.updateRoom();
      }

      // Flytter og skalerer plakaten på væggen (rummet er 300 × 187,5 cm, skænken står ved 115 cm)
      updateRoom() {
        if (!this.room) return;
        var poster = this.room.querySelector('[data-ppb-room-poster]');
        var cm = this.sizeCm(this.idx.size > -1 ? this.sel[this.idx.size] : '') || { w: 30, h: 40 };
        var k = Math.min(1, 98 / cm.h, 150 / cm.w);
        var w = cm.w * k;
        var h = cm.h * k;
        poster.style.left = (((150 - w / 2) / 300) * 100).toFixed(3) + '%';
        poster.style.top = (((103 - h) / 187.5) * 100).toFixed(3) + '%';
        poster.style.width = ((w / 300) * 100).toFixed(3) + '%';
        poster.style.height = ((h / 187.5) * 100).toFixed(3) + '%';
        var bg = this.bgStyle(this.valueObj('bg'));
        poster.style.background = bg;
        poster.classList.toggle('is-dark', this.isDark(bg));
        var f = this.frameInfo(this.idx.frame > -1 ? this.sel[this.idx.frame] : null);
        poster.classList.toggle('is-framed', !f.none);
        if (!f.none) poster.style.setProperty('--ppb-frame', f.color);
      }

      segBtn(value, label, meta, checked, disabled, onClick) {
        var btn = this.el('button', 'ppb-choice ppb-seg__btn');
        btn.type = 'button';
        btn.dataset.value = value;
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', String(checked));
        btn.disabled = disabled;
        var line = this.el('span', 'ppb-seg__label');
        line.appendChild(this.el('span', 'ppb-seg__check', '✓'));
        line.appendChild(document.createTextNode(label));
        btn.appendChild(line);
        if (meta) btn.appendChild(this.el('span', 'ppb-seg__meta', meta));
        btn.addEventListener('click', onClick);
        return btn;
      }

      // "✓ Med ramme | Uden ramme" – og ved "Med ramme" vises rammefarverne som rækker med et lille billede
      renderFrameSplit(values, prices, noneIdx, framedIdx, wrap, sub, subWrap) {
        var i = this.idx.frame;
        var cur = this.sel[i];
        var curFramed = !this.frameInfo(cur).none;
        var framedPrices = framedIdx.map((n) => prices[n]).filter((p) => p !== null);
        var minFramed = framedPrices.length ? Math.min.apply(null, framedPrices) : null;
        var noneVal = values[noneIdx[0]].name;
        var nonePrice = prices[noneIdx[0]];
        var tops = [nonePrice, minFramed].filter((p) => p !== null);
        var topBase = tops.length ? Math.min.apply(null, tops) : 0;
        var metaFor = (p) => (p === null ? this.t.unavailable : p > topBase ? '+' + this.fmt(p - topBase) : '');

        wrap.className = 'ppb-seg';
        wrap.textContent = '';
        wrap.appendChild(this.segBtn(noneVal, noneVal, metaFor(nonePrice), !curFramed, nonePrice === null, () => this.choose('frame', noneVal)));
        wrap.appendChild(
          this.segBtn('__framed', this.t.withFrame || 'Med ramme', metaFor(minFramed), curFramed, minFramed === null, () => {
            var ok = (n) => prices[n] !== null;
            var pick = framedIdx.find((n) => values[n].name === this.lastFramed && ok(n));
            if (pick === undefined) pick = framedIdx.filter(ok).sort((x, y) => prices[x] - prices[y])[0];
            if (pick !== undefined) this.choose('frame', values[pick].name);
          })
        );

        sub.hidden = !curFramed;
        subWrap.className = 'ppb-framelist';
        subWrap.textContent = '';
        framedIdx.forEach((n, k) => {
          var val = values[n];
          var price = prices[n];
          var diff = price !== null && minFramed !== null ? price - minFramed : 0;
          var btn = this.el('button', 'ppb-choice ppb-framerow');
          btn.type = 'button';
          btn.dataset.value = val.name;
          btn.setAttribute('role', 'radio');
          btn.setAttribute('aria-checked', String(cur === val.name));
          btn.disabled = price === null;
          var thumb = this.el('span', 'ppb-framerow__thumb');
          var img = (this.d.frameImages || [])[k];
          if (img) thumb.style.background = 'url("' + String(img).replace(/"/g, '%22') + '") center / cover no-repeat';
          else thumb.innerHTML = this.frameThumb(val.name);
          btn.appendChild(thumb);
          btn.appendChild(this.el('span', 'ppb-framerow__name', val.name));
          var meta = price === null ? this.t.unavailable : diff > 0 ? '+' + this.fmt(diff) : '';
          if (meta) btn.appendChild(this.el('span', 'ppb-framerow__meta', meta));
          btn.addEventListener('click', () => this.choose('frame', val.name));
          subWrap.appendChild(btn);
        });
      }

      // Tegner et hjørne af rammen i den rigtige farve
      frameThumb(name) {
        var f = this.frameInfo(name);
        var color = String(f.color || '#1e1e1e').replace(/[^#\w(),. %-]/g, '');
        return '<svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false">' +
          '<rect width="100" height="100" fill="#efedea"/>' +
          '<rect x="20" y="36" width="10" height="70" fill="rgba(0,0,0,.08)"/>' +
          '<rect x="28" y="28" width="80" height="80" fill="' + color + '" stroke="rgba(0,0,0,.16)" stroke-width="1"/>' +
          '<rect x="45" y="45" width="63" height="63" fill="#e6e3de"/>' +
          '<rect x="45" y="45" width="63" height="3" fill="rgba(0,0,0,.1)"/>' +
          '<rect x="45" y="45" width="3" height="63" fill="rgba(0,0,0,.06)"/>' +
          '</svg>';
      }

      updatePreview() {
        var poster = this.$('[data-ppb-poster]');
        var frame = this.$('[data-ppb-frame]');
        if (!poster || !frame) return;

        var bg = this.bgStyle(this.valueObj('bg'));
        poster.style.background = bg;
        poster.classList.toggle('is-dark', this.isDark(bg));

        var f = this.frameInfo(this.idx.frame > -1 ? this.sel[this.idx.frame] : null);
        frame.classList.toggle('is-framed', !f.none);
        if (!f.none) frame.style.setProperty('--ppb-frame', f.color);

        var sizeName = this.idx.size > -1 ? String(this.sel[this.idx.size] || '') : '';
        var dims = this.parseDims(sizeName);
        if (dims) poster.style.aspectRatio = dims.w + ' / ' + dims.h;

        var exPoster = this.$('[data-ppb-ex-poster]');
        if (exPoster) {
          exPoster.style.background = bg;
          exPoster.classList.toggle('is-dark', this.isDark(bg));
          var exFrame = this.$('[data-ppb-ex-frame]');
          exFrame.classList.toggle('is-framed', !f.none);
          if (!f.none) exFrame.style.setProperty('--ppb-ex-frame', f.color);
          var exColor = this.$('[data-ppb-ex-color]');
          if (exColor) exColor.textContent = this.idx.bg > -1 ? String(this.sel[this.idx.bg] || '').toLowerCase() : '';
        }

        var nameEl = this.$('[data-ppb-preview-name]');
        var typed = this.nameInput ? this.nameInput.value.trim() : '';
        var ph = String(this.t.namePlaceholder || '').replace(/^(fx\.?|f\.eks\.?|e\.g\.?|eg\.?|z\.b\.?)\s+/i, '');
        nameEl.textContent = typed || ph;
        nameEl.classList.toggle('is-placeholder', !typed);

        var img = this.$('[data-ppb-preview-img]');
        var paw = this.$('[data-ppb-paw]');
        var showImg = !!this.photoUrl && !this.photoBroken;
        img.hidden = !showImg;
        paw.style.display = '';
        var pet = img.closest('.ppb-preview__pet');
        if (pet) pet.classList.toggle('has-photo', showImg);
        var note = this.$('[data-ppb-drawnote]');
        if (note) {
          note.textContent = showImg
            ? 'Bare rolig – det er kun dit foto. Vi tegner det om til et flot portræt.'
            : this.later
              ? 'Du sender billedet til os efter købet – vi skriver til dig på mail.'
              : 'Vi tegner dit portræt ud fra billedet – det tager ca. 1 hverdag';
        }

        var list = this.$('[data-ppb-summary]');
        list.textContent = '';
        KEYS.forEach((k) => {
          var i = this.idx[k];
          if (i < 0) return;
          if (k === 'frame' && this.d.options[i].values.length < 2) return;
          var li = this.el('li');
          li.appendChild(this.el('span', null, this.d.options[i].name + ': '));
          li.appendChild(document.createTextNode(this.sel[i] || ''));
          list.appendChild(li);
        });
        if (this.photoUrl && !this.photoBroken) {
          var pli = this.el('li');
          pli.appendChild(this.el('span', null, 'Billede: '));
          pli.appendChild(document.createTextNode('Modtaget ✓'));
          list.appendChild(pli);
        } else if (this.later) {
          var lli = this.el('li');
          lli.appendChild(this.el('span', null, 'Billede: '));
          lli.appendChild(document.createTextNode('Sendes senere'));
          list.appendChild(lli);
        }
      }

      updateEta() {
        var el = this.$('[data-ppb-eta]');
        if (!el) return;
        var addWorkdays = (from, n) => {
          var d = new Date(from.getTime());
          while (n > 0) {
            d.setDate(d.getDate() + 1);
            var wd = d.getDay();
            if (wd !== 0 && wd !== 6) n--;
          }
          return d;
        };
        var now = new Date();
        var a = addWorkdays(now, Number(el.dataset.min) || 7);
        var b = addWorkdays(now, Number(el.dataset.max) || 12);
        var fmt;
        try {
          fmt = new Intl.DateTimeFormat('da-DK', { day: 'numeric', month: 'short' });
        } catch (e) {
          fmt = { format: (d) => d.getDate() + '/' + (d.getMonth() + 1) };
        }
        var out = this.$('[data-ppb-eta-dates]');
        if (out) out.textContent = fmt.format(a) + ' – ' + fmt.format(b);
        el.hidden = false;
      }

      updatePrice() {
        var v = this.variantFor(this.sel);
        var priceEl = this.$('[data-ppb-price]');
        var compareEl = this.$('[data-ppb-compare]');
        if (v) {
          this.variantInput.value = v.id;
          var extra = this.addonTotal();
          priceEl.textContent = this.fmt(v.price + extra);
          var hasCompare = v.compareAt && v.compareAt > v.price;
          compareEl.hidden = !hasCompare;
          compareEl.textContent = hasCompare ? this.fmt(v.compareAt + extra) : '';
        } else {
          priceEl.textContent = this.t.unavailable || '';
          compareEl.hidden = true;
        }
        this.nextBtn.disabled = !v || !v.available;
      }

      checkedAddons() {
        return (this.addonInputs || []).filter((cb) => cb.checked);
      }

      addonTotal() {
        return this.checkedAddons().reduce((sum, cb) => sum + (Number(cb.dataset.price) || 0), 0);
      }

      updateCount() {
        var c = this.$('[data-ppb-count]');
        if (c) c.textContent = this.nameInput.value.length + '/' + this.nameInput.maxLength;
      }

      /* ---------- steps ---------- */

      goTo(n, scroll) {
        if (this.steps.indexOf(n) === -1) return;
        this.step = n;
        var pos = this.steps.indexOf(n);
        var last = pos === this.steps.length - 1;
        this.querySelectorAll('[data-ppb-panel]').forEach((p) => {
          p.hidden = Number(p.dataset.ppbPanel) !== n;
        });
        this.$('[data-ppb-previewrow]').hidden = n < 2;
        this.backBtn.hidden = pos === 0;
        this.classList.toggle('is-last', last);
        this.$('[data-ppb-next-label]').textContent = last ? this.t.add : this.t.next;
        this.clearError();
        if (scroll !== false) {
          var top = this.getBoundingClientRect().top;
          if (top < 0) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      next() {
        if (this.loading) return;
        var pos = this.steps.indexOf(this.step);
        if (this.step === 3 && pos < this.steps.length - 1 && !this.validate()) return;
        if (pos < this.steps.length - 1) {
          this.goTo(this.steps[pos + 1]);
          return;
        }
        this.submit();
      }

      back() {
        if (this.loading) return;
        var pos = this.steps.indexOf(this.step);
        if (pos > 0) this.goTo(this.steps[pos - 1]);
      }

      /* ---------- photo ---------- */

      onFile(file) {
        this.clearError();
        this.drop.classList.remove('is-invalid');
        if (!file) {
          this.setPhoto(null);
          return;
        }
        var okType = /^image\//.test(file.type) || /\.(heic|heif|jpe?g|png|webp)$/i.test(file.name);
        var maxMb = Number(this.d.maxFileMb) || 20;
        if (!okType || file.size > maxMb * 1024 * 1024) {
          this.fileInput.value = '';
          this.setPhoto(null);
          this.drop.classList.add('is-invalid');
          this.showError(String(this.t.errorFile || '').replace('[MB]', maxMb));
          return;
        }
        this.setPhoto(file);
      }

      setPhoto(file) {
        if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
        this.photoUrl = file ? URL.createObjectURL(file) : null;
        this.photoBroken = false;
        if (file && this.later) this.setLater(false);
        this.drop.classList.toggle('has-file', !!file);
        this.classList.toggle('has-pic', !!file);
        this.checkQuality();
        this.$('[data-ppb-filename]').textContent = file ? file.name : '';

        var thumb = this.$('[data-ppb-thumb]');
        var img = this.$('[data-ppb-preview-img]');
        var onError = () => {
          this.photoBroken = true;
          thumb.style.visibility = 'hidden';
          this.updatePreview();
        };
        thumb.style.visibility = '';
        thumb.onerror = onError;
        img.onerror = onError;
        if (this.photoUrl) {
          thumb.src = this.photoUrl;
          img.src = this.photoUrl;
        } else {
          thumb.removeAttribute('src');
          img.removeAttribute('src');
        }
        this.updatePreview();
      }

      // Giver kunden ro i maven: er billedet stort nok til at tegne efter?
      checkQuality() {
        var q = this.$('[data-ppb-quality]');
        if (!q) return;
        q.classList.remove('is-warn');
        q.textContent = '✓ Billede modtaget';
        if (!this.photoUrl) return;
        var probe = new Image();
        probe.onload = () => {
          var m = Math.min(probe.naturalWidth, probe.naturalHeight);
          var ok = m >= 700;
          q.classList.toggle('is-warn', !ok);
          q.textContent = ok
            ? '✓ Godt billede – det kan vi tegne ud fra'
            : 'Billedet er lidt lille – har du et skarpere, så vælg gerne det';
        };
        probe.src = this.photoUrl;
      }

      /* ---------- add to cart ---------- */

      showError(msg) {
        this.errorEl.textContent = msg || this.t.errorGeneric || '';
        this.errorEl.hidden = false;
      }

      clearError() {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }

      validate() {
        if (!this.later && (!this.fileInput.files || !this.fileInput.files.length)) {
          this.drop.classList.add('is-invalid');
          this.showError(this.t.errorPhoto);
          this.fileInput.focus();
          return false;
        }
        if (!this.nameInput.value.trim()) {
          this.nameInput.classList.add('is-invalid');
          this.showError(this.t.errorName);
          this.nameInput.focus();
          return false;
        }
        return true;
      }

      setLoading(on) {
        this.loading = on;
        this.nextBtn.classList.toggle('is-loading', on);
        this.nextBtn.disabled = on;
        this.nextBtn.setAttribute('aria-busy', String(on));
        if (this.stickyBar) this.syncSticky();
      }

      checkoutUrl() {
        var root = String((this.d.routes && this.d.routes.root) || '/');
        return (root.slice(-1) === '/' ? root : root + '/') + 'checkout';
      }

      async submit() {
        if (!this.validate()) {
          if (this.step !== 3) {
            this.goTo(3);
            this.validate();
          }
          return;
        }
        var v = this.variantFor(this.sel);
        if (!v || !v.available) {
          this.showError(this.t.unavailable);
          return;
        }
        this.variantInput.value = v.id;
        this.nameInput.value = this.nameInput.value.trim();
        this.setLoading(true);
        try {
          var body = new FormData(this.form);
          // "Send billedet senere": send ikke et tomt foto-felt med
          if (this.later || !this.fileInput.files || !this.fileInput.files.length) body.delete('properties[Foto]');
          var res = await fetch(this.d.routes.cartAdd, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: body,
          });
          var json = {};
          try {
            json = await res.json();
          } catch (e) {}
          if (!res.ok || json.status) {
            var err = new Error(json.description || json.message || '');
            err.fromShop = true;
            throw err;
          }
          var addons = this.checkedAddons();
          if (addons.length) {
            var petName = this.nameInput.value;
            try {
              await fetch(String(this.d.routes.cartAdd).replace(/\/?$/, '') + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                  items: addons.map((cb) => ({
                    id: Number(cb.value),
                    quantity: 1,
                    properties: petName ? { 'Til portræt af': petName } : {},
                  })),
                }),
              });
            } catch (e) {}
          }
          // Åbn kurv-skuffen på siden (som West & Willow). Findes den ikke, går vi til kurv-siden.
          if (this.d.after !== 'checkout' && (await this.openCartDrawer(v.id))) {
            this.setLoading(false);
            return;
          }
          window.location.href = this.d.after === 'checkout' ? this.checkoutUrl() : this.d.routes.cart;
        } catch (err) {
          this.setLoading(false);
          this.showError(err && err.fromShop && err.message ? err.message : this.t.errorGeneric);
        }
      }
    }

    // Fortæller temaet (Horizon), at kurven er ændret, så kurv-skuffen og tallet ved kurven opdateres – og åbner skuffen
    PetPortraitBuilder.prototype.openCartDrawer = async function (variantId) {
      var drawer = document.querySelector('theme-drawer#cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return false;
      try {
        var mod = await import('@shopify/events');
        var Ev = mod && mod.CartLinesUpdateEvent;
        if (!Ev || typeof Ev.createPromise !== 'function') return false;
        var deferred = Ev.createPromise();
        this.dispatchEvent(
          new Ev({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(variantId), quantity: 1 }],
            promise: deferred.promise,
          })
        );
        var root = String(this.d.routes.root || '/').replace(/\/?$/, '/');
        var cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        deferred.resolve({
          cart: Ev.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'pet-portrait-builder', itemCount: 1, didError: false },
        });
      } catch (e) {
        return false;
      }
      setTimeout(() => {
        if (!drawer.isOpen) drawer.open();
      }, 60);
      return true;
    };

    customElements.define('pet-portrait-builder', PetPortraitBuilder);
  })();
  } catch(e) { console.error(e); }
})();

})();
